import { axiosInstance, API_PREFIX, type ApiResponse, type RequestParams } from '@/shared/api';
import type { ApiResponseList } from '@/shared/api/types';
import type { PurchaseBase, PurchaseById, PurchaseCreatePayload } from '../model/types';

const BASE = `${API_PREFIX.ADMIN_V1}/purchase`;

export const getList = async (params?: RequestParams): Promise<ApiResponseList<PurchaseBase>> => {
  const { data } = await axiosInstance.get<ApiResponseList<PurchaseBase>>(`${BASE}/index`, { params });
  return data;
};

export const getByGroupId = async (groupId: string): Promise<ApiResponse<PurchaseById>> => {
  const { data } = await axiosInstance.get<ApiResponse<PurchaseById>>(`${BASE}/show`, {
    params: { group_id: groupId },
  });
  return data;
};

export const create = async (payload: PurchaseCreatePayload): Promise<ApiResponse<PurchaseById>> => {
  const { data } = await axiosInstance.post<ApiResponse<PurchaseById>>(`${BASE}/create`, payload);
  return data;
};
